import React from "react";
import {
  BasicTooltip,
  tooltipPositions
} from "@streeteasy/design-system/tooltip";
import { bool, oneOf, string } from "prop-types";

import { checkCircle } from "./assets";
import * as S from "./styled";

const ImageBox = ({ imgSrc, isFeatured, isVerified, openHouse, theme }) => (
  <S.ImageWrapper theme={theme}>
    <S.Image alt="" aria-hidden src={imgSrc} />
    <S.ImageLabels>
      {isFeatured && (
        <S.ImageLabel>
          <S.FeaturedLabel>Featured</S.FeaturedLabel>
        </S.ImageLabel>
      )}
      {openHouse && (
        <S.ImageLabel>
          <S.OpenHouseLabel>{openHouse}</S.OpenHouseLabel>
        </S.ImageLabel>
      )}
    </S.ImageLabels>
    {isVerified && (
      <S.CheckIcon>
        <BasicTooltip
          content="Verified up to date"
          position={tooltipPositions.TOP}
        >
          <S.TooltipButton>
            <img alt="" src={checkCircle} />
          </S.TooltipButton>
        </BasicTooltip>
      </S.CheckIcon>
    )}
  </S.ImageWrapper>
);

ImageBox.defaultProps = {
  isFeatured: false,
  isVerified: false,
  openHouse: null,
  theme: "verticalCard"
};

ImageBox.propTypes = {
  imgSrc: string.isRequired,
  isFeatured: bool,
  isVerified: bool,
  openHouse: string,
  theme: oneOf(["horizontalCard", "verticalCard"])
};

export default ImageBox;
